export class ContactResetPasswordDTO {
    public email: string
    public returnUrl: string
    public website: string
    constructor(
        email: string,
        returnUrl: string,
        website: string,
    ) {
        this.email = email
        this.returnUrl = returnUrl
        this.website = website
    }
}
